<button [class]="'buttonIcon ' + ' ' + fromVisibility(visibility) + ' ' + fromSize(size)" [type]="type"
        [class._disabled]="disabled" [disabled]="disabled" [tabIndex]="tabindex" (click)="doAction($event)">
    <div (click)="doAction($event)">
        <ng-content></ng-content>
    </div>
</button>
